<template>
    <div>
        <div class="row">
            <div class="col-lg-3 d-none d-lg-block" style="height: 85vh;"></div>
            <div class="col-lg-6 d-flex align-items-center mt-5 mt-lg-0">
                <div class="card login w-100 p-5">
                    <h4 class="text-center mb-4">جهت مشاهده آموزش هر بخش میتوانید روی علامت سوال روی آیکون هر بخش کلیک
                        کرده و آموزش آنلاین آن بخش را مشاهده کنید</h4>
                    <h4 class="text-center mb-4">جهت مشاهده لیست آموزشها روی<a href="https://www.aparat.com/it_badian"
                                                                               target="_blank" class="font-weight-bold">
                        این لینک </a> کلیک کنید</h4>
                    <h4 class="text-center mb-4">در صورت وجود ابهام یا سوال میتوانید در ساعات اداری با شماره
                        (32761127-026) و در ساعات غیر اداری با شماره (09222760495) تماس بگیرید</h4>
                </div>


            </div>
            <div class="col-lg-4"></div>
            <!--<div class="col-12">-->
                <!--<hr/>-->
                <!--<div class="barcode">-->
                    <!--<div class="col-lg-6  mb-2">-->
                        <!--<div class="input-group">-->
                            <!--<button type="button" class="d-inline-block btn btn-info mx-2" @click="openBarcode"><i-->
                                    <!--class="fa fa-camera"></i></button>-->
                            <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">بارکد</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" type="number" v-model="barcode">-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"-->
                 <!--aria-hidden="true">-->
                <!--<div class="modal-dialog modal-lg modal-dialog-centered" role="document">-->
                    <!--<div class="modal-content">-->
                        <!--<div class="modal-header bg-warning-grad glow-warning">-->
                            <!--<h5 class="modal-title text-white" id="voucherTitle">خواندن بارکد-->
                                <!--محصول</h5>-->

                            <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
                                <!--<span aria-hidden="true">&times;</span>-->
                            <!--</button>-->
                        <!--</div>-->
                        <!--<div class="modal-body mt-3">-->
                            <!--<div class="row">-->
                                <!--<div class="col-12">-->

                                    <!--<StreamBarcodeReader-->
                                            <!--@decode="(a, b, c) => onDecode(a, b, c)"-->
                                            <!--@loaded="() => onLoaded()"-->
                                    <!--&gt;</StreamBarcodeReader>-->
                                    <!--<h5 class="col-12 text-center m-3">{{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="modal-footer mt-3">-->
                            <!--<button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>-->
                            <!--&lt;!&ndash;<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>&ndash;&gt;-->
                            <!--&lt;!&ndash;<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>&ndash;&gt;-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import EventBus from '../_framework/event-bus.js';
    import * as $ from "jquery";
    import axios from "axios";
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from "../_framework/VsSelect";
    import Constants from "../Constants";
    import Cities from '../_framework/api/Cities'
    import {StreamBarcodeReader} from "vue-barcode-reader";

    export default {
        name: 'profile',
        components: {
            VsSelect,
            StreamBarcodeReader
        },
        data() {
            return {
                user: {
                    personName: "",
                    personBigName: "",
                    phoneNumber: "",
                    city: "",
                    province: "",
                    image: "",
                    gender: 1
                },
                provinces: [],
                cities: [],
                preselectedProvince: {},
                preselectedCity: {},
                text: "",
                id: null,
                barcode: "",

            }
        },
        mounted() {
            this.provinces = Cities;
            $("#avatar").on("change", () => {
                var preview = $("#user-img");
                var file = document.querySelector('input[type=file]').files[0];
                var reader = new FileReader();
                var base64;
                reader.addEventListener("load", function () {
                    $("#user-img").attr("src", reader.result);
                    //this.user.image = reader.result;
                    base64 = reader.result;
                }, false);
                setTimeout(() => {
                    this.user.image = base64;
                }, 1000);

                if (file) {
                    reader.readAsDataURL(file);
                }
            });
            axios.defaults.baseURL = Constants.AUTH_API_BASE_URL;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem("token_mobile");
            axios.get('persons/0').then(response => {
                this.user = response.data;
                localStorage.setItem("userId", this.user.id);
                $("#user-img").attr('src', this.user.image);
                this.preselectedProvince = {name: this.user.province};
                this.preselectedCity = {name: this.user.city};
            });
            this.user.phoneNumber = localStorage.getItem("phoneNumber");
            /*axios.get('Worker/GetCities').then(response => {
                this.cities = response.data.cities;
                for (let item of this.cities) {
                    if (item.cityId === parseInt(this.user.cityCode)) {
                        this.preselectedCity = item;
                    }
                }
            });*/
        },
        methods: {
            onSubmitClicked() {
                this.user.gender = 1;
                this.user.image = this.user.image.split(",").pop();
                axios.put('persons', this.user).then(response => {
                    if (JSON.parse(localStorage.getItem("isRegistered"))) {
                        this.$noty.success('اطلاعات کاربری با موفقیت ویرایش شد!');
                    } else {
                        this.$noty.success('اطلاعات کاربری با موفقیت ثبت شد!');
                    }
                    localStorage.setItem("isRegistered", "true");
                    this.$router.push({name: 'select-store'});
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onProvinceChange(val) {
                let province = this.provinces.find(element => {
                    return element === val;
                });
                this.user.province = val.name;
                this.cities = province.cities;
            },
            onCityChange(val) {
                this.user.city = val.name;
            },
            onDecode(a, b, c) {
                console.log(a, b, c);
                this.text = a;
                this.barcode = a;
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                console.log("load");
            },
            openBarcode() {
                this.barcode="";
                $("#barcodeModal").modal("show");
            },
        }
    }
</script>

<style lang="scss" scoped>
    .user-img {
        max-width: 125px;
        border-radius: 100%;
    }

    @media (max-width: 991px) {
        .barcode {
            display: block;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none;
        }
    }
</style>